import React, { useEffect, useState } from 'react';

import { graphql } from 'gatsby';

import { CustomerQuote, QuoteData } from '@mewa/ui';

import { StrapiImage } from '../../templates/dynamic-content-page/content-components/image';
import { CustomerReport } from './types';

export type StrapiCustomerReports = {
  customerReports: {
    nodes: CustomerReport[];
  };
  customerQuoteTranslations: {
    customer_quote_headline: string;
  };
};

export const query = graphql`
  fragment CustomerReportFragment on Query {
    customerReports: allStrapiCustomerReport(
      filter: { locale: { eq: $locale } }
    ) {
      nodes {
        customerName: CustomerName
        customerQuotes: CustomerQuotes {
          title: Title
          quote: Quote
          image: Image {
            ...StrapiImageFileFragment
          }
          quoteGiverText: QuoteGiverText
        }
      }
    }

    customerQuoteTranslations: translation(locale: { eq: $locale }) {
      customer_quote_headline
    }
  }
`;

export const CustomerQuoteWrapper = ({
  customerReports,
  headline,
}: {
  customerReports: CustomerReport[];
  headline?: string;
}) => {
  const [quoteData, setQuoteData] = useState<QuoteData | undefined>(() => {
    const customerQuote = customerReports[0]?.customerQuotes[0];

    return customerQuote
      ? {
          headline,
          quote: customerQuote.quote,
          image: customerQuote.image ? (
            <StrapiImage image={customerQuote.image} />
          ) : undefined,
          customerName: customerReports[0]?.customerName || '',
          quoteGiverText: customerQuote.quoteGiverText,
        }
      : undefined;
  });

  useEffect(() => {
    const customerReport =
      customerReports[Math.floor(Math.random() * customerReports.length)];
    const randomCustomerQuote = customerReport
      ? customerReport.customerQuotes[
          Math.floor(Math.random() * customerReport.customerQuotes.length)
        ]
      : undefined;
    setQuoteData(
      randomCustomerQuote && {
        headline,
        quote: randomCustomerQuote.quote,
        image: randomCustomerQuote.image ? (
          <StrapiImage image={randomCustomerQuote.image} />
        ) : undefined,
        customerName: customerReport?.customerName || '',
        quoteGiverText: randomCustomerQuote.quoteGiverText,
      },
    );
  }, [customerReports, headline]);

  return quoteData ? <CustomerQuote data={quoteData} /> : null;
};
